import { render, staticRenderFns } from "./FoodItem.vue?vue&type=template&id=0e010294&scoped=true&"
import script from "./FoodItem.vue?vue&type=script&lang=js&"
export * from "./FoodItem.vue?vue&type=script&lang=js&"
import style0 from "./FoodItem.vue?vue&type=style&index=0&id=0e010294&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e010294",
  null
  
)

export default component.exports